import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Typography, Stack} from 'views/components';
import {Accordion, AccordionDetails, AccordionSummary} from 'views/components';

import {Translate} from 'views/module';

import CaregiverContacts from './caregiver_contact/CaregiverContacts';
import CaregiverAuth from './caregiver_auth/CaregiverAuth';
import CaregiverProfileUrl from './caregiver_profile_url/CaregiverProfileUrl';

const CaregiverSettings = (props) => {
  const view = props.caregiverSettingsView;
  const setView = props.setCaregiverSettingsView;

  const handleChange = (panel) => (event, isExpanded) => {
    setView(isExpanded ? panel : '');
  };

  // Accordion configuration array
  const accordions = [
    {
      id: 'PROFILE_URL',
      title: 'caregiver.CaregiverDetail.Settings.ProfileUrl.Title',
      Component: CaregiverProfileUrl,
    },
    {
      id: 'CONTACT',
      title: 'caregiver.CaregiverDetail.Settings.Contact.Title',
      Component: CaregiverContacts,
    },
    {
      id: 'AUTH',
      title: 'caregiver.CaregiverDetail.Settings.Auth.Title',
      Component: CaregiverAuth,
    },
  ];

  return (
    <Stack spacing={2} sx={{mr: 2}}>
      {
        accordions.map(({id, title, Component}) => (
          <Accordion
            key={id}
            expanded={view === id}
            onChange={handleChange(id)}
            sx={{marginBottom: '16px'}}
            TransitionProps={{unmountOnExit: true}}
            disableGutters
          >
            <AccordionSummary
              sx={{
                'flexDirection': 'row-reverse',
                '& .MuiAccordionSummary-content': {
                  marginLeft: '8px',
                },
                '&.Mui-expanded': {
                  minHeight: '0px',
                },
                'borderBottom': '1px solid rgba(0, 0, 0, 0.12)',
                'textTransform': 'uppercase',
              }}
            >
              <Typography sx={{textTransform: 'uppercase', fontWeight: 500, color: 'black'}}>
                <Translate expression={title} />
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                paddingTop: '8px',
                paddingBottom: '0px',
                overflow: 'auto',
              }}
            >
              <Component
                {...props}
              />
            </AccordionDetails>
          </Accordion>
        ))
      }
    </Stack>
  );
};

CaregiverSettings.propTypes = {
  caregiverSettingsView: PropTypes.string.isRequired,
  setCaregiverSettingsView: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(CaregiverSettings));
